import { createSelector } from 'reselect';
import { getWorkOrderManagement } from './getWorkOrderManagement';

/**
 * The current job's work order operation ref as stored: undefined with no current job, null for a
 * job without one (a labor ticket with no operation). A primitive, so selectors can take it as an
 * input without recomputing on every workOrderManagement write. Read from the store rather than
 * getCurrentWorkOrderOp, whose module imports those selectors.
 */
export const getCurrentWorkOrderOpRef = createSelector(
  [getWorkOrderManagement],
  (workOrderManagement) => {
    const currentWorkOrderOp = workOrderManagement?.currentWorkOrderOp;
    if (currentWorkOrderOp == null) return undefined;
    return currentWorkOrderOp.workOrderOperationRef ?? null;
  }
);
